<template>
    <div>
        <div class="columns">
            <div class="column">
                <label class="label">Start</label>
                <input class="input oc-input" type="datetime" v-model="start" />
            </div>
            <div class="column">
                <label class="label">End</label>
                <input class="input oc-input" type="datetime" v-model="end" />
            </div>
            <div class="column">
                <a class="button is-pulled-right" @click="refresh">
                    <span class="icon">
                        <i class="fas fa-sync-alt"></i>
                    </span>
                    <span>Refresh</span>
                </a>
            </div>
        </div>

        <p class="title is-5">Bonuses</p>

        <table class="table is-fullwidth is-hoverable is-size-7">
            <thead>
                <tr>
                    <th>Id</th>
                    <th>Player</th>
                    <th>Created</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Bet / Win</th>
                    <th>Estimated amount</th>
                    <th>Payout</th>
                    <th>Completed at (reason)</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="bonus in bonuses" :key="bonus.id">
                    <td>{{bonus.id}}</td>
                    <td>
                        <router-link
                            :to="{ name: 'player', params: { clientId: clientId, playerId: bonus.userId } }"
                        >{{ bonus.userId }}</router-link>
                    </td>
                    <td>{{bonus.created | datetime}}</td>
                    <td>{{bonus.start | datetime}}</td>
                    <td>{{bonus.end | datetime}}</td>
                    <td>{{bonus.bet | currency(bonus.currency)}} / {{bonus.win | currency(bonus.currency)}}</td>
                    <td>{{bonus.estimatedAmount | currency(bonus.currency)}}</td>
                    <td>{{bonus.amount | currency(bonus.currency)}}</td>
                    <td
                        v-if="bonus.completed"
                    >{{bonus.completed | datetime}} ({{bonus.completeReason}})</td>
                    <td v-if="!bonus.completed">-</td>
                </tr>
            </tbody>
        </table>

        <p class="title is-5">Total</p>
        <table class="table is-fullwidth is-hoverable is-size-7">
            <thead>
                <tr>
                    <th>Currency</th>
                    <th>Payout</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in total" :key="item.currency">
                    <td>{{item.currency}}</td>
                    <td>{{item.payout | currency(item.currency)}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import Vue from 'vue';
import moment from 'moment-timezone';
import bonusService from '../../../../services/bonus.service';
import currencyService from '../../../../services/currency.service';

export default {
    name: 'client-bonuses-cashback',
    data() {
        return {
            start: moment()
                .startOf('week')
                .toDate(),
            end: moment()
                .endOf('week')
                .toDate(),
            bonuses: [],
            total: []
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    async mounted() {
        await currencyService.ensure();
        await this.refresh();
    },
    methods: {
        async refresh() {
            var data = await bonusService.getClientCashbackHistory(this.clientId, this.start, this.end);
            this.bonuses = data.bonuses;
            this.total = data.total;
        }
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/bonuses/cashback.vue